import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeUpdatePrescriptionMutation as useDeUpdatePrescriptionMutationType } from "@/modules/patients/detail/prescription/de/services/__generated__/useDeUpdatePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeUpdatePrescriptionMutation($input: De_updatePrescriptionInput!) {
    de_updatePrescription(input: $input) {
      de_Prescription {
        id
        ...dePrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdatePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeUpdatePrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdatePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdatePrescriptionMutation }
